import React from "react";
import styled from "styled-components";
import type {
  ContentReference,
  ProductionBrief,
} from "../../../../../database/mediaOps/contentApi";
import { Hint } from "../pipeline/ui";
const Summary = styled.div`
  display: grid;
  gap: var(--space-3);
  padding-block: var(--space-3);
  p {
    margin: 0;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
  a {
    color: var(--color-accent);
    overflow-wrap: anywhere;
  }
`;
export const safeReferenceLink = (value: string) => {
  try {
    const u = new URL(value);
    return u.protocol === "https:" && !u.username && !u.password
      ? value
      : undefined;
  } catch {
    return undefined;
  }
};
const fields = [
  ["instructions", "Creative direction"],
  ["storyboard", "Slide outline or storyboard"],
  ["carouselPrompt", "Carousel prompt"],
  ["videoPrompt", "Video prompt"],
  ["mediaNotes", "Media instructions"],
] as const;
export default function ProductionPlanningSummary({
  brief,
  references = [],
}: {
  brief?: ProductionBrief;
  references?: ContentReference[];
}) {
  return (
    <Summary>
      {brief && (
        <>
          <p>
            Brief v{brief.version} · {brief.format} · {brief.aspectRatio}
            {brief.template ? ` · ${brief.template}` : ""}
          </p>
          {fields
            .filter(([field]) => brief[field])
            .map(([field, label]) => (
              <div key={field}>
                <strong>{label}</strong>
                <p>{brief[field]}</p>
              </div>
            ))}
          <Hint>
            {brief.libraryAssetIds.length + brief.assetIds.length} selected
            media items
          </Hint>
        </>
      )}
      {references.map((r) => (
        <div key={r.id}>
          <strong>{r.title}</strong>
          {safeReferenceLink(r.url) && (
            <p>
              <a
                href={safeReferenceLink(r.url)}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open reference
              </a>
            </p>
          )}
          <p>{[r.creator, r.locator].filter(Boolean).join(" · ")}</p>
          <p>{r.notes}</p>
          {r.rightsNote && <Hint>{r.rightsNote}</Hint>}
        </div>
      ))}
    </Summary>
  );
}
